import React, { ReactElement } from 'react';

export const HelpText: React.FC<{
    children: ReactElement | string;
    style?: React.CSSProperties | undefined;
}> = ({ children, style }) => {
    return (
        <small className="form-text text-muted" style={style}>
            {children}
        </small>
    );
};
